import React from "react";
import RegionIcon from "./RegionIcon";

function RegionCheckbox(props) {
    const { value, checked, onChange, labelHtml } = props;

    return (
        <label className="trpr-sf-region-checkbox">
            <input
                className="trpr__visually-hidden"
                type="checkbox"
                checked={checked}
                value={value}
                onChange={onChange}
                name="region"
            />
            <div className="trpr-sf-region-checkbox__icon-container">
                <RegionIcon
                    id={value}
                    countryColor={checked ? "#a7a5f9" : "#D5D5D5"}
                    regionColor={checked ? "#504cf3" : "#999999"}
                />
            </div>
            <span className="trpr-sf-region-checkbox__label" dangerouslySetInnerHTML={{ __html: labelHtml }} />
        </label>
    );
}

export default RegionCheckbox;
